module.exports = __webpack_public_path__ + "img/First Bank of Nigeria.6b1884d1.png";